export const MEMBER_TOKEN_STORAGE_KEY = 'member-token';
export const SCREEN_SELECTION_STORAGE_KEY = 'screen-selection';